<div class="flex flex-col items-center gap-6 p-6 relative">
  <button
    class="absolute top-2 right-2 p-2 hover:bg-surface-100 dark:hover:bg-surface-800 rounded-full transition-colors"
    (click)="close()">
    <i class="pi pi-times text-surface-500 dark:text-surface-400"></i>
  </button>

  <canvas #qrCanvas></canvas>

  <span class="text-4xl font-mono tracking-widest">{{ connectionCode }}</span>
</div>
